module.exports = __webpack_public_path__ + "assets/retina_AEqualSegments1Detailed.d3f5a17dbea4025c1ed0799d16465b87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_AEqualSegments1Detailed.png
// module id = 606
// module chunks = 0